/* eslint-disable */

import React from "react";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import Currency from "../../../ui-components/currency/currency.tsx";
import { fetchOrganisationDashboardGet } from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

const DashboardWidget = ({ title, icon, children }) => {
  return (
    <div
      className={`flex flex-col w-full max-w-xs rounded-lg p-6 border gap-4
      dark:bg-color-dark-background-secondary  bg-color-background-secondary 
      dark:border-color-dark-border-secondary border-color-border-secondary
      `}
    >
      <div className="flex flex-row text-left w-full gap-2 items-center text-color-dark-text-secondary">
        <i className={`text-xl ${icon}`} />
        <div className="text-sm font-bold">{title.toUpperCase()}</div>
      </div>

      <div>{children}</div>
    </div>
  );
};

const CirrusHome = ({ currentOrganisationUser }) => {
  const [dashboardInfo, setDashboardInfo] = React.useState(null);

  useEffect(() => {
    // Fetch the dashboard info
    // setDashboardInfo()
    console.log("RD-5556");
    fetchOrganisationDashboardGet({
      organisationId: currentOrganisationUser.organisation.id,
    }).then((response) => {
      console.log("RD-5557");
      setDashboardInfo(response);
    });
    console.log("RD-5558");
  }, []);

  if (!dashboardInfo) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className={`flex flex-col w-full h-full gap-6`}>
      <div className="text-4xl font-bold">Home</div>

      <DashboardWidget title={"Total Supporters"} icon="fas fa-people-group">
        {dashboardInfo.total_current_supporters == 1 && (
          <div className="text-2xl font-bold">
            {dashboardInfo.total_current_supporters} user
          </div>
        )}
        {dashboardInfo.total_current_supporters != 1 && (
          <div className="text-2xl font-bold">
            {dashboardInfo.total_current_supporters} users
          </div>
        )}
      </DashboardWidget>

      {dashboardInfo.total_contributions.map((contribution) => (
        <DashboardWidget title={"Total Contributions"} icon="fas fa-coins">
          <Currency
            subunits={contribution.subunits}
            currency={contribution.subunits_currency}
            isStylised={true}
          />
        </DashboardWidget>
      ))}
      {dashboardInfo.total_contributions_pending.map((contribution) => (
        <DashboardWidget
          title={"Total Pending Contributions"}
          icon="fas fa-coins"
        >
          <Currency
            subunits={contribution.subunits}
            currency={contribution.subunits_currency}
            isStylised={true}
          />
        </DashboardWidget>
      ))}
    </div>
  );
};

export default CirrusHome;
